//import { Helmet } from "react-helmet-async";
import { Helmet } from 'react-helmet';
import Message from '../../component/Message';
import CompareSlider from '../../component/compareSlider';
//import Media from '../components/SocialMedia';

const BlogIndex = () => {
  return (
    <div className="">
      <Helmet>
        <title>آموزش تغذیه - آذر شفیعی - صفحه اصلی وبلاگ آموزشی لاغری </title>
        <meta name="description" content="contact ISO organization" />
      </Helmet>
      <div className="flex flex-row">
        {/* <h1 className="text-2xl font-custom1 text-main">
          آموزش تغذیه - آذر شفیعی - صفحه اصلی وبلاگ آموزشی لاغری
        </h1> */}
        <CompareSlider
          img1={'https://backend.fitlinez.com/uploads/file-1700719422979.jpg'}
          img2={'https://backend.fitlinez.com/uploads/file-1713679776511.JPG'}
        />
        <CompareSlider
          img1={'https://backend.fitlinez.com/uploads/file-1714913137955.jpeg'}
          img2={
            'https://backend.fitlinez.com/Compress_20241112_110637_7818.jpg'
          }
        />
        <CompareSlider
          img1={'https://backend.fitlinez.com/uploads/file-1701071979944.jpg'}
          img2={
            'https://backend.fitlinez.com/1733152796801-5llqye998w2-IMG_2843.jpeg'
          }
        />
        <CompareSlider
          img1={'https://backend.fitlinez.com/uploads/file-1719066270830.png'}
          img2={'https://backend.fitlinez.com/IMG_5869.png'}
        />
        {/* <Media /> */}
      </div>
      <div className="flex flex-col items-center mt-10">
        {/* <Message /> */}
      </div>
    </div>
  );
};

export default BlogIndex;
